// extracted by mini-css-extract-plugin
export default {"navigation":"Reviews_navigation__8x3cV","slide":"Reviews_slide__x0EKn","image":"Reviews_image__-36lk","name":"Reviews_name__wuF+1","description":"Reviews_description__bOWif"};